(() => {
  const maybeRedirectGermanVisitor = () => {
    const path = location.pathname || '/';
    if (path === '/de' || path.startsWith('/de/')) return;
    if (window.Shopify?.designMode) return;
    if (sessionStorage.getItem('qh-de-redirected') === '1') return;
    const languages = navigator.languages?.length ? navigator.languages : [navigator.language];
    const wantsGerman = languages.some(language => String(language || '').toLowerCase().startsWith('de'));
    if (!wantsGerman) return;
    sessionStorage.setItem('qh-de-redirected', '1');
    const target = `/de${path === '/' ? '/' : path}${location.search}${location.hash}`;
    location.replace(target);
  };
  maybeRedirectGermanVisitor();

  const bind = () => document.querySelectorAll('[data-qh-product]').forEach(root => {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';
    const track = root.querySelector('[data-qh-track]');
    const slides = [...root.querySelectorAll('[data-qh-slide]')];
    const thumbs = [...root.querySelectorAll('[data-qh-thumb]')];
    const prev = root.querySelector('[data-qh-prev]');
    const next = root.querySelector('[data-qh-next]');
    const count = root.querySelector('[data-qh-count]');
    const dialog = root.querySelector('.qh-zoom-dialog');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0, frame = 0, drag = null;
    const update = index => {
      if (!Number.isFinite(index)) return;
      active = Math.max(0, Math.min(slides.length - 1, index));
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active === slides.length - 1;
      if (count) count.textContent = `${active + 1} / ${slides.length}`;
    };
    const go = index => {
      if (!track || !slides.length) return;
      update(index);
      track.scrollTo({left: slides[active].offsetLeft - slides[0].offsetLeft, behavior: reduced.matches ? 'instant' : 'smooth'});
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => go(index)));
    prev?.addEventListener('click', () => go(active - 1));
    next?.addEventListener('click', () => go(active + 1));
    track?.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (track.clientWidth > 0) update(Math.round(track.scrollLeft / track.clientWidth));
      });
    }, {passive: true});
    track?.addEventListener('keydown', event => {
      const actions = {ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: slides.length - 1};
      if (!(event.key in actions)) return;
      event.preventDefault(); go(actions[event.key]);
    });
    // Touch uses the browser's native scroll and snapping. Mouse dragging gets the same behavior.
    track?.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = {x: event.clientX, left: track.scrollLeft, id: event.pointerId, moved: false};
      track.setPointerCapture(event.pointerId);
    });
    track?.addEventListener('pointermove', event => {
      if (!drag) return;
      const delta = event.clientX - drag.x;
      if (Math.abs(delta) > 5 && !drag.moved) {
        drag.moved = true; track.classList.add('is-dragging');
      }
      if (drag.moved) track.scrollLeft = drag.left - delta;
    });
    const finishDrag = () => {
      if (!drag) return;
      const moved = drag.moved;
      drag = null; track.classList.remove('is-dragging');
      if (moved && track.clientWidth > 0) go(Math.round(track.scrollLeft / track.clientWidth));
    };
    track?.addEventListener('pointerup', finishDrag);
    track?.addEventListener('pointercancel', finishDrag);
    if (track && window.ResizeObserver) new ResizeObserver(() => {
      if (!drag && track.clientWidth > 0) track.scrollTo({left: active * track.clientWidth, behavior: 'instant'});
    }).observe(track);
    const warm = () => slides.forEach(slide => {
      const image = slide.querySelector('img');
      if (image?.decode) image.decode().catch(() => {});
    });
    if ('requestIdleCallback' in window) requestIdleCallback(warm, {timeout: 1500}); else setTimeout(warm, 300);
    const isGerman = document.documentElement.lang?.toLowerCase().startsWith('de') || location.pathname.startsWith('/de/');
    const select = root.querySelector('[data-qh-variant]');
    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0], available = option.dataset.available === 'true';
      root.querySelector('[data-qh-price]').textContent = option.dataset.price;
      const compare = root.querySelector('[data-qh-compare-price]');
      if (compare) {
        compare.textContent = option.dataset.comparePrice || '';
        compare.hidden = !option.dataset.comparePrice;
      }
      const saleBadge = root.querySelector('[data-qh-sale-badge]');
      if (saleBadge) { saleBadge.hidden = !option.dataset.discount; saleBadge.textContent = option.dataset.discount ? `${isGerman ? 'SPARE' : 'SAVE'} ${option.dataset.discount}%` : ''; }
      const buy = root.querySelector('[data-qh-buy]'); buy.disabled = !available;
      root.querySelector('[data-qh-buy-label]').textContent = available ? (isGerman ? 'In die Tasche legen' : 'Add to bag') : (isGerman ? 'Ausverkauft' : 'Sold out');
      root.querySelector('[data-qh-availability]').textContent = available ? (isGerman ? 'Bestellbar' : 'Available to order') : (isGerman ? 'Derzeit nicht verfügbar' : 'Currently unavailable');
      const index = thumbs.findIndex(thumb => thumb.dataset.src === option.dataset.image);
      if (index >= 0) go(index);
      const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
    });
    root.querySelector('[data-qh-zoom]')?.addEventListener('click', () => {
      const image = slides[active]?.querySelector('img');
      if (!dialog || !image) return;
      const zoom = dialog.querySelector('img'); zoom.src = thumbs[active]?.dataset.src || image.currentSrc || image.src; zoom.alt = image.alt;
      dialog.showModal();
    });
    root.querySelector('[data-qh-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });

    const bindStockBars = () => root.querySelectorAll('[data-qh-stock-bar]').forEach(bar => {
      if (bar.dataset.stockBound) return;
      bar.dataset.stockBound = 'true';
      const countNode = bar.querySelector('[data-qh-stock-count]');
      const base = Number(bar.dataset.stockBase) || 13;
      const minimum = Math.max(1, Number(bar.dataset.stockMin) || base - 4);
      const firstDropMs = Math.max(10, Number(bar.dataset.stockFirstDropSeconds) || 20) * 1000;
      const secondDropMs = Math.max(firstDropMs + 1000, (Number(bar.dataset.stockSecondDropSeconds) || 80) * 1000);
      const laterDropMs = Math.max(60, Number(bar.dataset.stockLaterDropSeconds) || 120) * 1000;
      const cycleMs = Math.max(secondDropMs + laterDropMs, Number(bar.dataset.stockCycleHours) || 4) * 60 * 60 * 1000;
      const maxDrop = Math.max(0, base - minimum);
      const key = `qh-stock-cycle:v2:${location.pathname}:${base}:${minimum}:${firstDropMs}:${secondDropMs}:${laterDropMs}:${cycleMs}`;
      const dropCount = elapsed => {
        if (maxDrop <= 0 || elapsed < firstDropMs) return 0;
        if (elapsed < secondDropMs) return 1;
        return Math.min(maxDrop, 2 + Math.floor((elapsed - secondDropMs) / laterDropMs));
      };
      const readState = () => {
        try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch (error) { return {}; }
      };
      const writeState = state => {
        try { localStorage.setItem(key, JSON.stringify(state)); } catch (error) {}
      };
      let state = readState();
      const now = Date.now();
      if (!state.startedAt || now - state.startedAt >= cycleMs || state.startedAt > now) {
        state = { startedAt: now, lastCount: base };
        writeState(state);
      }
      const render = () => {
        const currentTime = Date.now();
        if (currentTime - state.startedAt >= cycleMs) {
          state = { startedAt: currentTime, lastCount: base };
          writeState(state);
        }
        const elapsed = currentTime - state.startedAt;
        const drops = dropCount(elapsed);
        const current = Math.max(minimum, base - drops);
        const progress = Math.max(8, Math.min(32, current * 2));
        if (countNode) countNode.textContent = current;
        bar.style.setProperty('--qh-stock-progress', `${progress}%`);
        if (state.lastCount && current < state.lastCount) {
          bar.classList.remove('is-dropping');
          requestAnimationFrame(() => bar.classList.add('is-dropping'));
          window.setTimeout(() => bar.classList.remove('is-dropping'), 800);
        }
        state.lastCount = current;
        writeState(state);
      };
      render();
      window.setInterval(render, 1000);
    });
    bindStockBars();
    update(0);
  });
  bind(); document.addEventListener('shopify:section:load', bind);
})();
